module.exports = __webpack_public_path__ + "img/united-states-logo-icon.1d4d9b61.png";